namespace TabAurous.Common {
    export interface CommonBOMForm {
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        BOMProductId: Serenity.ServiceLookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BOMAttributeId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ItemType: Serenity.StringEditor;
        Attribute: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        StoneSizeId: StoneSizeLookup;
        GroupSieveId: StoneSieveLookup;
        MetalColorId: Serenity.LookupEditor;
        TextureId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        SettingId: Serenity.LookupEditor;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        Purity: Serenity.DecimalEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        Parts: Serenity.IntegerEditor;
        GrossWeight: Serenity.DecimalEditor;
        PointerWeight: Serenity.DecimalEditor;
        PureWeight: Serenity.DecimalEditor;
        CalcOnId: Serenity.LookupEditor;
        BomRate: AmountEditor;
        Markup: Serenity.DecimalEditor;
        BomAmount: AmountEditor;
        CCBomAmount: AmountEditor;
        Remarks: Serenity.StringEditor;
        CostMethodId: Serenity.LookupEditor;
    }

    export class CommonBOMForm extends Serenity.PrefixedContext {
        static formKey = 'Common.CommonBOMForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CommonBOMForm.init)  {
                CommonBOMForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.LookupEditor;
                var w3 = s.ServiceLookupEditor;
                var w4 = CommonCategoryLookup;
                var w5 = CommonSubCategoryLookup;
                var w6 = StoneSieveLookup;
                var w7 = StoneSizeLookup;
                var w8 = s.DecimalEditor;
                var w9 = WeightEditor;
                var w10 = AmountEditor;

                Q.initFormType(CommonBOMForm, [
                    'ItemTypeId', w0,
                    'ProductId', w1,
                    'ProductTypeId', w2,
                    'BOMProductId', w3,
                    'CategoryId', w4,
                    'SubCategoryId', w5,
                    'BOMAttributeId', w1,
                    'ProductCode', w1,
                    'ItemType', w1,
                    'Attribute', w1,
                    'Lab', w2,
                    'CertificateNo', w1,
                    'KaratId', w2,
                    'ShapeId', w2,
                    'SieveId', w6,
                    'StoneSizeId', w7,
                    'GroupSieveId', w6,
                    'MetalColorId', w2,
                    'TextureId', w2,
                    'StoneColorId', w2,
                    'QualityId', w2,
                    'SettingId', w2,
                    'StoneCutId', w2,
                    'StonePolishId', w2,
                    'StoneSymmetryId', w2,
                    'StoneFluorescenceId', w2,
                    'StoneCuletId', w2,
                    'StoneGirdleId', w2,
                    'StoneTable', w1,
                    'StoneDepth', w1,
                    'Purity', w8,
                    'Pieces', w0,
                    'Weight', w9,
                    'Parts', w0,
                    'GrossWeight', w8,
                    'PointerWeight', w8,
                    'PureWeight', w8,
                    'CalcOnId', w2,
                    'BomRate', w10,
                    'Markup', w8,
                    'BomAmount', w10,
                    'CCBomAmount', w10,
                    'Remarks', w1,
                    'CostMethodId', w2
                ]);
            }
        }
    }
}
